import mutations from '@/store/modules/notify/mutations'
import state from '@/store/modules/notify/state'

export default {
    mutations,
    state
}